// extracted by mini-css-extract-plugin
export var root = "carousel-modules--root--3wY1P";
export var counter = "carousel-modules--counter--2X9_v";